module.exports = __webpack_public_path__ + "img/icon-success-ani.76ff4cdb.gif";